export default __webpack_public_path__ + "static/media/logo_pink.7e95dc60.png";